import { updateServiceFees } from '../../../actions/ServiceFees/updateServiceFees';

async function submit(values, dispatch) {

	dispatch(
		updateServiceFees(
			values.guestType,
			values.guestValue,
			values.hostType,
			values.hostValue,
			values.currency,
			values.globleListTax
		)
	);
}

export default submit;
